import { mainApi } from '../../../api/mainApi';
import { AccessState } from '../../../types';
import { middlewareApi } from '../../middleware/middlewareApi';

export const transactionCollTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['Transaction'],
});
// Define a service using a base URL and expected endpoints
export const transactionCollApi = transactionCollTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET get receipt pdf by transaction id
     */
    getReceiptByTransactionId: builder.query<
      string,
      {
        profileId?: number;
        idTransaction: number;
      }
    >({
      queryFn: async ({ profileId, idTransaction }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.get<string>(
            `/cash-collection/collection-transaction/${idTransaction}/recover-receipt-pdf`,
            {
              responseType: 'arraybuffer',
              headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json',
              },
              params: {
                ...(profileId ? { user_profile_id: profileId } : { user_profile_id }),
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error, { idTransaction }) => [{ type: 'Transaction', idTransaction }],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetReceiptByTransactionIdQuery, useLazyGetReceiptByTransactionIdQuery } =
  transactionCollApi;
